import { useFormContext } from '@calendly/form'
import { useDispatch, useSelector } from 'react-redux'

import { Email2FAModal } from 'features/email_2fa_modal'
import { isMfaOpenSelector } from 'features/invite_flow/selectors'
import { closeMfa } from 'features/invite_flow/slice'


export const MfaModal = ({ onConfirm }) => {
  const dispatch = useDispatch()
  const isMfaOpen = useSelector(isMfaOpenSelector)
  const { values: { eventTypeIds, invitations, groupId } } = useFormContext()
  const onClose = () => dispatch(closeMfa())
  const onContinue = async ({ code }) => {
    await onConfirm({
      invitations,
      eventTypeIds,
      groupId,
      verificationCode: code
    })
    onClose()
  }

  if (!isMfaOpen) return null

  return (
    <Email2FAModal onClose={onClose} onContinue={onContinue} />
  )
}
